"use strict";

exports.__esModule = true;
exports.Collection = void 0;
exports.searchAndFilter = searchAndFilter;
var _react = require("react");
var _RestAPI = require("../../API/RestAPI");
var _SortButton = require("../../Core/SortButton");
var _Utils = require("../../../Utils");
var _excluded = ["id"];
var _dec, _class, _Collection;
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Provides access to items of a certain type via the API.
 *
 * An optional `localStore` (list / get / has / set / remove, see
 * AI/Authoring/aiDraftsStore) overlays documents kept in the browser: they
 * appear in searches, win over the API's copy of the same id, and are read,
 * updated and deleted locally instead of through the API.
 */
var Collection = exports.Collection = (_dec = _RestAPI.RestAPIContext.withContext, _dec(_class = (_Collection = /*#__PURE__*/function (_Component) {
  function Collection() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      cache: {},
      hasSearched: false,
      // Bumped when a browser draft is saved, so a getter already showing that
      // id (or its failed load) fetches again.
      localVersion: 0,
      getItemURL: function getItemURL(input) {
        return _this.getItemURL(input);
      },
      getItemURLById: function getItemURLById(id) {
        return _this.getItemURLById(id);
      },
      evictFromCacheById: function evictFromCacheById(id, callback) {
        var url = _this.getItemURLById(id);
        _this.evictFromCache(url, callback);
      },
      /* Fetch the items and perform a search  */
      search: function () {
        var _search = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(term, filterPredicate) {
          var _this$props, api, baseURL, sortConfig, items, sortedItems, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this$props = _this.props, api = _this$props.api, baseURL = _this$props.baseURL, sortConfig = _this$props.sortConfig;
                _t = _this;
                _context.n = 1;
                return api.get(baseURL);
              case 1:
                items = _t.mergeLocal.call(_t, _context.v);
                sortedItems = sortItems(items, sortConfig);
                _this.setState({
                  hasSearched: true
                });
                _this.populateCache(sortedItems);
                return _context.a(2, searchAndFilter(sortedItems, term, filterPredicate));
            }
          }, _callee);
        }));
        function search(_x, _x2) {
          return _search.apply(this, arguments);
        }
        return search;
      }(),
      /* Perform a search on the cache  */
      optimisticSearch: function optimisticSearch(term, filterPredicate, parseSearchItem) {
        var _this$state = _this.state,
          cache = _this$state.cache,
          hasSearched = _this$state.hasSearched;
        if (!hasSearched) {
          return;
        }
        var keys = Object.keys(cache);
        if (keys.length === 0) {
          return;
        }
        var items = [];
        for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
          var key = _keys[_i];
          var item = cache[key];
          items.push(item);
        }
        var sortConfig = _this.props.sortConfig;
        var sortedItems = sortItems(items, sortConfig);
        return searchAndFilter(sortedItems, term, filterPredicate, parseSearchItem);
      },
      create: function () {
        var _create = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(input) {
          var _this$props2, primaryKey, api, baseURL, item, url;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this$props2 = _this.props, primaryKey = _this$props2.primaryKey, api = _this$props2.api, baseURL = _this$props2.baseURL;
                if (!input[primaryKey]) {
                  _context2.n = 2;
                  break;
                }
                url = _this.getItemURL(input);
                _context2.n = 1;
                return api.put(url, input);
              case 1:
                item = _context2.v;
                _context2.n = 4;
                break;
              case 2:
                _context2.n = 3;
                return api.post(baseURL, input);
              case 3:
                item = _context2.v;
              case 4:
                _this.populateCache([item]);
                return _context2.a(2, item);
            }
          }, _callee2);
        }));
        function create(_x3) {
          return _create.apply(this, arguments);
        }
        return create;
      }(),
      read: function () {
        var _read = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id, useCache) {
          var _this$props3, api, apiInterface, localStore, cache, url, local, cached, item, _t2;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this$props3 = _this.props, api = _this$props3.api, apiInterface = _this$props3.apiInterface, localStore = _this$props3.localStore;
                cache = _this.state.cache;
                url = _this.getItemURLById(id);
                if (!(localStore && localStore.has(id))) {
                  _context3.n = 1;
                  break;
                }
                local = localStore.get(id);
                _this.populateCache([local]);
                return _context3.a(2, local);
              case 1:
                cached = cache[url];
                if (!(cached !== undefined && useCache)) {
                  _context3.n = 2;
                  break;
                }
                return _context3.a(2, cached);
              case 2:
                if (!(apiInterface && apiInterface.getById)) {
                  _context3.n = 4;
                  break;
                }
                _context3.n = 3;
                return apiInterface.getById(id);
              case 3:
                _t2 = _context3.v;
                _context3.n = 6;
                break;
              case 4:
                _context3.n = 5;
                return api.get(url);
              case 5:
                _t2 = _context3.v;
              case 6:
                item = _t2;
                _this.populateCache([item]);
                return _context3.a(2, item);
            }
          }, _callee3);
        }));
        function read(_x4, _x5) {
          return _read.apply(this, arguments);
        }
        return read;
      }(),
      optimisticRead: function optimisticRead(id) {
        var cache = _this.state.cache;
        var localStore = _this.props.localStore;
        if (localStore && localStore.has(id)) {
          return localStore.get(id);
        }
        var url = _this.getItemURLById(id);
        return cache[url];
      },
      /* Whether the item with this id lives in the browser, not the API. */
      isLocal: function isLocal(id) {
        var localStore = _this.props.localStore;
        return Boolean(localStore && localStore.has(id));
      },
      /* Keep an item in the browser (create or replace) and in the cache. */
      saveLocal: function saveLocal(item) {
        var localStore = _this.props.localStore;
        if (!localStore) {
          throw new Error("This collection has no local store");
        }
        // The store may complete the item (see normalizeAiDocument); cache
        // and hand back what it kept.
        var saved = localStore.set(item) || item;
        _this.populateCache([saved]);
        _this.setState(function (state) {
          return {
            localVersion: state.localVersion + 1
          };
        });
        return saved;
      },
      update: function () {
        var _update = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(input) {
          var _this$props4, api, updateMethod, localStore, primaryKey, url, item;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _this$props4 = _this.props, api = _this$props4.api, updateMethod = _this$props4.updateMethod, localStore = _this$props4.localStore, primaryKey = _this$props4.primaryKey;
                url = _this.getItemURL(input);
                if (!(localStore && localStore.has(input[primaryKey]))) {
                  _context4.n = 1;
                  break;
                }
                localStore.set(input);
                _this.populateCache([input]);
                return _context4.a(2, input);
              case 1:
                _context4.n = 2;
                return updateMethod === "PUT" ? api.put(url, input) : api.post(url, input);
              case 2:
                item = _context4.v;
                if (!(item === true)) {
                  _context4.n = 3;
                  break;
                }
                _this.populateCache([input]);
                return _context4.a(2, input);
              case 3:
                _this.populateCache([item]);
                return _context4.a(2, item);
            }
          }, _callee4);
        }));
        function update(_x6) {
          return _update.apply(this, arguments);
        }
        return update;
      }(),
      updateWithoutID: function () {
        var _updateWithoutID = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(input) {
          var _this$props5, api, updateMethod, _id, extra, url, item;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                _this$props5 = _this.props, api = _this$props5.api, updateMethod = _this$props5.updateMethod;
                _id = input.id, extra = _objectWithoutPropertiesLoose(input, _excluded);
                url = _this.getItemURL(input);
                _context5.n = 1;
                return updateMethod === "PUT" ? api.put(url, extra) : api.post(url, extra);
              case 1:
                item = _context5.v;
                _this.setState({
                  hasSearched: false,
                  cache: {}
                });
                return _context5.a(2, item);
            }
          }, _callee5);
        }));
        function updateWithoutID(_x7) {
          return _updateWithoutID.apply(this, arguments);
        }
        return updateWithoutID;
      }(),
      "delete": function () {
        var _delete2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(id) {
          var _this$props6, api, localStore, url;
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.n) {
              case 0:
                _this$props6 = _this.props, api = _this$props6.api, localStore = _this$props6.localStore;
                url = _this.getItemURLById(id);
                if (!(localStore && localStore.has(id))) {
                  _context6.n = 1;
                  break;
                }
                localStore.remove(id);
                _this.evictFromCache(url);
                return _context6.a(2, true);
              case 1:
                _context6.n = 2;
                return api["delete"](url);
              case 2:
                _this.evictFromCache(url);
                return _context6.a(2, true);
            }
          }, _callee6);
        }));
        function _delete(_x8) {
          return _delete2.apply(this, arguments);
        }
        return _delete;
      }(),
      clearCache: function clearCache(callback) {
        _this.setState(function () {
          return {
            cache: {}
          };
        }, callback);
      }
    };
    return _this;
  }
  _inheritsLoose(Collection, _Component);
  var _proto = Collection.prototype;
  // The API's items with the browser's drafts laid over them: a draft with
  // an id the API also has replaces it, the others are added.
  _proto.mergeLocal = function mergeLocal(items) {
    var _this$props7 = this.props,
      localStore = _this$props7.localStore,
      primaryKey = _this$props7.primaryKey;
    if (!localStore) {
      return items;
    }
    var locals = localStore.list();
    if (!locals || locals.length === 0) {
      return items;
    }
    var key = function key(item) {
      return String(item[primaryKey]);
    };
    var byId = new Map(locals.map(function (item) {
      return [key(item), item];
    }));
    var merged = items.map(function (item) {
      return byId.has(key(item)) ? byId.get(key(item)) : item;
    });
    var seen = new Set(items.map(key));
    for (var _iterator = _createForOfIteratorHelperLoose(locals), _step; !(_step = _iterator()).done;) {
      var local = _step.value;
      if (!seen.has(key(local))) {
        merged.push(local);
      }
    }
    return merged;
  };
  _proto.populateCache = function populateCache(items) {
    var _this2 = this;
    this.setState(function (state) {
      var cache = Object.assign({}, state.cache);
      for (var _iterator2 = _createForOfIteratorHelperLoose(items), _step2; !(_step2 = _iterator2()).done;) {
        var item = _step2.value;
        var key = _this2.getItemURL(item);
        cache[key] = item;
      }
      return {
        cache: cache
      };
    });
  };
  _proto.getItemURLById = function getItemURLById(id) {
    var _this$props8 = this.props,
      primaryKey = _this$props8.primaryKey,
      baseURL = _this$props8.baseURL,
      itemBaseURL = _this$props8.itemBaseURL;
    var url = itemBaseURL;
    if (!url) {
      url = baseURL.endsWith("/") ? baseURL + ":id" : baseURL + "/:id";
    }
    return url.replace(":" + primaryKey, String(id));
  };
  _proto.getItemURL = function getItemURL(item) {
    var primaryKey = this.props.primaryKey;
    var id = item[primaryKey];
    return this.getItemURLById(id);
  };
  _proto.evictFromCache = function evictFromCache(url, callback) {
    this.setState(function (state) {
      var cache = {};
      for (var _i2 = 0, _Object$keys = Object.keys(state.cache); _i2 < _Object$keys.length; _i2++) {
        var key = _Object$keys[_i2];
        if (key !== url) {
          cache[key] = state.cache[key];
        }
      }
      return {
        cache: cache
      };
    }, callback);
  };
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return Collection;
}(_react.Component), _Collection.defaultProps = {
  primaryKey: "id",
  updateMethod: "POST",
  api: undefined,
  localStore: undefined
}, _Collection)) || _class);
function searchAndFilter(items, term, filterPredicate, parseSearchItem) {
  if (term) {
    var termPredicate = createTermMatcher(term, parseSearchItem);
    return items.filter(function (item) {
      return termPredicate(item) && (filterPredicate ? filterPredicate(item) : true);
    });
  }
  return filterPredicate ? items.filter(filterPredicate) : items;
}
function createTermMatcher(term, parseSearchItem) {
  var toMatch = term.toLowerCase();
  return function (item) {
    var objectToMatch = typeof parseSearchItem === "function" ? parseSearchItem(item) : item;
    var keys = Object.keys(objectToMatch);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var value = objectToMatch[key];
      if (typeof value !== "string" && typeof value !== "number") {
        continue;
      }
      var candidate = String(value).toLowerCase();
      if (candidate.includes(toMatch)) {
        return true;
      }
    }
    return false;
  };
}
function sortItems(items, sortConfig) {
  if (sortConfig) {
    if (sortConfig.sortArrayOfObjectsByKey) {
      return (0, _Utils.sortArrayOfObjectsByKey)(items, sortConfig.prop);
    }
    return (0, _SortButton.applySort)(items, sortConfig.prop, sortConfig.order);
  }
  return items;
}